import { createLiWithText } from "../DomUtilities/ElementsCreator";

export default function openErrorModal(text?: string | string[], color?: string, header?: string, width?: string, height?: string) {
	const errorModal = document.getElementById("error");
	const modal: HTMLDivElement = errorModal.querySelector(".modal");
	const h4: HTMLHeadingElement = errorModal.querySelector('h4');
	const p: HTMLParagraphElement = errorModal.querySelector('p');
	errorModal.style.display = "flex";
	const errorText = h4.innerText;
	const errorTextColor = h4.style.color;
	const errorHeader = p.innerText;

	if (width) {
		modal.style.width = width;
	}

	if (height) {
		modal.style.height = height;
	}

	if (text) {
		h4.innerHTML = "";
		if (typeof (text) === "string") {
			h4.innerText = text;
		} else {
			const errorlist: HTMLUListElement = document.createElement('ul');
			errorlist.append(...text.map(t => createLiWithText(t)));
			h4.appendChild(errorlist);
			h4.style.textAlign = "start";
		}
		if (color) {
			h4.style.color = color;
		}
	}

	if (header) {
		p.innerText = header;
	}

	const img: HTMLImageElement = errorModal.querySelector('img[alt="close icon"]');
	window.onclick = img.onclick = function (event) {
		if (event.target == errorModal || event.target == img) {
			errorModal.style.display = "none";
			h4.innerHTML = "";
			h4.innerText = errorText;
			h4.style.color = errorTextColor;
			p.innerText = errorHeader;
			h4.style.textAlign = "center";
		}
	}
}
